/* eslint-disable max-len */
import React from "react"

import BaseSvgIcon from "../Base"

const CultureHubFill = (props) => (
  <BaseSvgIcon {...props} viewBox="0 0 44 44">
    <path
      d="M26.6804 5.5496C25.9204 5.9896 25.6504 6.9696 26.1004 7.7296L35.4504 23.9296C35.8904 24.6896 36.8704 24.9596 37.6304 24.5096C38.3904 24.0596 38.6604 23.0896 38.2104 22.3296L28.8604 6.1296C28.4204 5.3696 27.4404 5.0996 26.6804 5.5496Z"
      fill="#000"
    />
    <path
      d="M6.36983 24.1697C5.60983 24.6097 5.33983 25.5897 5.78983 26.3497L9.16983 32.1997C9.60983 32.9597 10.5898 33.2297 11.3498 32.7797C12.1098 32.3297 12.3798 31.3597 11.9298 30.5997L8.54983 24.7497C8.10983 23.9897 7.12983 23.7197 6.36983 24.1697Z"
      fill="#000"
    />
    <path
      d="M21.5996 37.7904C21.7896 38.4704 22.6296 38.8304 23.4896 38.5904C23.6496 38.5404 23.7996 38.4804 23.9396 38.4004C24.1696 38.2704 24.3596 38.1004 24.4696 37.9104C24.6896 37.6304 24.7596 37.2604 24.6796 36.9304L22.4796 28.9404L19.3896 29.7504L21.6096 37.8004L21.5996 37.7904Z"
      fill="#000"
    />
    <path d="M13.4404 29.2896L33.2504 24.0596L24.8804 9.55957L10.4404 24.0996L13.4404 29.2896Z" fill="#000" />
  </BaseSvgIcon>
)

export default CultureHubFill
